import React, { useState } from "react"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"
import { parse as parseQueryParams } from "query-string"

import { useLocation } from "store/contexts/location"
import { Container, MBGLogo, Content, Terms } from "./styles"
import Form from "./form"
import EnterCode from "./enter-code"

const screens = {
  FORM: "form",
  ENTER_CODE: "enter-code",
}

const LoginPasswordless = ({ from = "page", onSuccess, onClose, customRedirectTo }) => {
  const [currentScreen, setCurrentScreen] = useState(screens.FORM)

  const { location } = useLocation()
  const redirectTo = customRedirectTo || parseQueryParams(location.search).redirectTo

  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.GATSBY_RECAPTCHA_SITE_KEY}>
      <Container>
        <Content>
          <MBGLogo />
          {currentScreen === screens.FORM && (
            <Form
              switchScreen={() => setCurrentScreen(screens.ENTER_CODE)}
              redirectTo={redirectTo}
            />
          )}
          {currentScreen === screens.ENTER_CODE && (
            <EnterCode
              closeModal={onClose}
              switchScreen={() => setCurrentScreen(screens.FORM)}
              onSuccess={onSuccess}
              redirectTo={redirectTo}
              from={from}
            />
          )}
          <Terms>
            By signing up, I agree to mindbodygreen&apos;s{" "}
            <a href="/terms-of-use" target="_blank" rel="noreferrer">
              {" "}
              Terms of Use{" "}
            </a>{" "}
            &
            <a href="/privacy" target="_blank" rel="noreferrer">
              {" "}
              Privacy Policy
            </a>
            .
          </Terms>
        </Content>
      </Container>
    </GoogleReCaptchaProvider>
  )
}

export default LoginPasswordless
